import { c as _c } from "react/compiler-runtime";
export default function Anchor(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.anchorId) {
    t0 = <div id={props.anchorId} />;
    $[0] = props.anchorId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}